<template>
    <div>
        <external-link-dialog
            v-if="btnFields && btnFields.externalLink"
            :link="btnFields.externalLink"
            :dialog="dialog"
            @close="dialog = false"
        />
        <email-dialog
            v-if="btnFields && btnFields.type === 'Download Guide'"
            v-model="downloadGuideModal"
            is-download
            @download="downloadAsset()"
        />
    </div>
</template>

<script>
/** This component can be used similar to the btn-mixin, but it will handle the dialogs for you
 * so you do not need to do that in the parent component. Simply pass in a prop of the btn-id, and
 * use a ref to call the click method.
 */
import BtnMixin from '@/mixins/btn-mixin'
import ExternalLinkDialog from '@/components/dialogs/external-link-dialog'
import EmailDialog from '@/components/dialogs/email-dialog'
export default {
  name: 'HiddenBtn',
  components: {
    ExternalLinkDialog,
    EmailDialog
  },
  // Remember, btnMixin has a prop of btn-id (string), so pass that in
  mixins: [BtnMixin],
  data: function () {
    return {
      dialog: false
    }
  },
  methods: {
    click () {
      // Call this outside the component with a ref
      this.btnClick() // mixin method
    }
  }
}
</script>
